"use client";

import { useContext } from "react";

import { LocaleContext } from "./locale-context";

export const useLocale = () => useContext(LocaleContext);
